import honorWallCore from "./honorWallCore.cjs";

export const PORTRAIT_COUNT = honorWallCore.PORTRAIT_COUNT;
export const LANDSCAPE_COUNT = honorWallCore.LANDSCAPE_COUNT;
export const VISIBLE_PORTRAIT_COUNT = honorWallCore.VISIBLE_PORTRAIT_COUNT;
export const VISIBLE_LANDSCAPE_COUNT = honorWallCore.VISIBLE_LANDSCAPE_COUNT;
export const DEFAULT_ROTATION_SECONDS = honorWallCore.DEFAULT_ROTATION_SECONDS;
export const createDefaultHonorWall = honorWallCore.createDefaultHonorWall;
export const normalizeHonorWall = honorWallCore.normalizeHonorWall;
export const getVisibleHonorItems = honorWallCore.getVisibleHonorItems;
